import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _globalUtilityService: GlobalUtilityService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      // catchError((error: HttpErrorResponse) => {
      //   if (error.status === 401) {
      //     this._globalUtilityService.logOut();
      //   }
      //   return throwError(() => new Error(error.message));
      // })
    );
  }
}
